require('./bootstrap');

// Flatpickr
import flatpckr from 'flatpickr';
window.flatpckr = flatpckr;
import 'flatpickr/dist/l10n/de';
